<script>
const selectProps = {
  backgroundColor: "white",
  outlined: true,
  light: true,
};

const textFieldProps = {
  backgroundColor: "white",
  outlined: true,
  light: true,
};

const textFieldLikeProps = {
  ...textFieldProps,
  color: 'inherit'
};

const additionalProps =  {
  'v-text-field': textFieldProps,
  'text-field-like': textFieldLikeProps,
  'hds-id-field': textFieldLikeProps,
  'local-id-field': textFieldLikeProps,
  'owner-field': textFieldLikeProps,
  'dictionary-name-field': textFieldLikeProps,
  'v-select': selectProps,
  'model-select': selectProps,
  'process-component-model-select': selectProps,
};

export default {
  name: "ToolbarInline",
  props: {
    closeLeft: {
      type: Boolean,
      default: false
    }
  },
  render(h) {
    const inputVNode = Array.isArray(this.$slots.default) && this.$slots.default[0];
    if(!inputVNode) {
      return null;
    }
    const compOptions = inputVNode.componentOptions;
    compOptions.propsData = {
      ...compOptions.propsData,
      ...additionalProps[compOptions.tag],
      dense: true,
      hideDetails: true,
    };
    return h('div', {
      class: {
        'toolbar-inline': true,
        'ml-2': !this.closeLeft,
      }
    }, [inputVNode]);
  },
}
</script>

<style scoped>
.toolbar-inline {
  max-width: 300px;
  white-space: nowrap;
}
</style>
